"use client";
import {
  applyFormQueryParams,
  eventList,
  loadEventList,
  loadCities,
  loadLocations,
  loadCategories,
  cityNames,
  locationNames,
  categoryNames,
} from "@/app/events/store/event-list.store";
import { IEventV2 } from "@/app/dashboard/models/Event";
import { EventCard } from "@/app/common/components/EventCard";
import { useSignals } from "@preact/signals-react/runtime";
import { useEffect } from "react";
import { CircleOff } from "lucide-react";

const onInitAsync = async (params) => {
  if (!cityNames.value.length) {
    await loadCities();
  }
  if (!locationNames.value.length) {
    await loadLocations();
  }
  if (!categoryNames.value.length) {
    await loadCategories();
  }
  applyFormQueryParams(params);
  await loadEventList();
};

export const EventList = ({ params }) => {
  useSignals();

  useEffect(() => {
    onInitAsync(params);
  }, [params]);
  return (
    <>
      {eventList.value.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-3 py-16">
          <CircleOff size={32} strokeWidth={1.5} className="stroke-stone-neutral-11" />
          <p className="text-base text-stone-neutral-11">
            We couldn't find any events. Adjust your filters and try again
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {eventList.value.map((event: IEventV2) => (
            <EventCard event={event} key={event.id} />
          ))}
        </div>
      )}
    </>
  );
};
